import React from 'react';
import { Button } from '@moment/components/Button/Button.tsx';
import { HOMEPAGE_ROUTE_PATH } from '@pages/Root/router/constants.ts';
import { useTranslation } from 'react-i18next';
import './NotFound.scss';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-page">
      <img src={'/assets/images/error-404.svg'} alt="404" />
      <h1 className="title-lg">404</h1>
      <h2 className="title-md">{t('pageNotFound')}</h2>
      <Button label={t('goToHomePage')} onClick={() => { window.location.href = HOMEPAGE_ROUTE_PATH; }} />
    </div>
  );
};

export default NotFound;